import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ILeadProps } from "entity/lead/Lead/Lead";

const Lead = lazyLoadWithRetry(() => import("./Lead"));

export const RouteLead = (props: Omit<ILeadProps, "leadId" | "history" | "match" | "location">) => (
    <RouteRelative
        path={routes.lead.details}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <Lead
                        {...props}
                        {...routeProps}
                        leadId={parseInt(routeProps.match.params.id) ?? -1}
                    />
                </BTSuspense>
            );
        }}
    />
);
